import { MDXRenderer } from 'gatsby-plugin-mdx'

export default MDXRenderer